import { Skeleton as MuiSkeleton } from '@mui/material';

export const Skeleton = () => (
  <MuiSkeleton variant="rounded" animation="wave" width="100%" height={250} />
);
